
import { selector } from "../api";
import { Navigate } from "react-router-dom";

export default function PrivateRoute ({ children }) {

  const isAuth = selector.Auth()

  if(!isAuth) {
    return <Navigate to="/" replace/>
  }


  return children

}